// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Select from 'react-select';

export default class NumberChooser extends Component {

  static defaultProps = {
    min: 0,
    max: 500,
    step: 1,
    reverse: false
  };

  static propTypes = {
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    step: PropTypes.number,
    reverse: PropTypes.bool,
    onChange: PropTypes.func
  };

  // -- events
  onChange = (option) => {
    this.props.onChange(option.value);
  };

  // -- renderers

  render() {
    const options = _.range(this.props.min, this.props.max + 1, this.props.step);

    if (this.props.reverse) {
      options.reverse();
    }

    return (
      <Select
        onChange={this.onChange}
        value={this.props.value}
        options={options.map(value => ({ label: value, value }))}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/components/form/NumberChooser.js